import React from 'react'
import cn from 'classnames'
import { FormattedMessage } from 'react-intl'

import styles from './styles.module.css'

interface IRequestSentPreview {
  children?: string | React.ReactElement
  icon: React.ComponentType<React.SVGAttributes<SVGElement>>
  hasBackground?: boolean
  title?: string
}

const RequestSentPreview: React.FC<IRequestSentPreview> = ({
  children,
  icon: Icon,
  hasBackground,
  title,
}) => {
  const baseClassName = cn(styles.requestSent, {
    [styles.requestSentWithBackground]: hasBackground,
  })
  return (
    <div className={baseClassName}>
      <p className={styles.requestSentTitle}>
        <Icon className={styles.requestSentTitleIcon} /> {title}
      </p>
      <p className={styles.requestSentMessage}>
        {children || <FormattedMessage id="room.special-requests-confirmation" />}
      </p>
    </div>
  )
}

export default RequestSentPreview
RequestSentPreview.displayName = 'RequestSentPreview'
